import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconDialpadStarMark",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  d: "M10.13 5.596c.109-.05.086-.246-.031-.273-1.745-.4-3.104-2-3.395-4.005-.02-.133-.246-.164-.293-.04-.752 2.397-2.378 4.272-4.542 5.186-.106.052-.084.234.029.262 1.704.423 3.027 1.993 3.324 3.96.02.13.227.158.275.037.866-2.507 2.525-4.39 4.633-5.127Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function p(e, u, r, f, h, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--dialpad-star-mark"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dialpad Star Mark",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const k = /* @__PURE__ */ l(o, [["render", p]]);
export {
  k as default
};
//# sourceMappingURL=dialpad-star-mark.js.map
